export class ReportService {
  async exportDetalleCotizaciones(baseUrl, estados) {
    if (!Array.isArray(estados) || estados.length === 0) {
      throw new Error("Se requiere al menos un estado para exportar");
    }

    const query = estados
      .map((estado) => `estados=${encodeURIComponent(estado)}`)
      .join("&");

    const response = await fetch(
      `${baseUrl}exportDetalleCotizaciones?${query}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error(
        `Error al exportar detalle de documentos (${response.status})`
      );
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "detalle_documentos.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
}
